import { SpriteView } from '../../ui_canvas_engine/SpriteView.ts';
import { Sprites } from '../UIGameImageDictionary.ts';
import { UIGameSpriteHandler } from '../../UIGameSpriteHandler.ts';
import { UIGameVerticalMovementAnimation } from '../../ui_canvas_engine/UIGameVerticalMovementAnimation.ts';
export class UIGameBeginnerHintIndicatorView {
    destroy() {
        var _this_view;
        this.animationController.stop();
        (_this_view = this.view) === null || _this_view === void 0 ? void 0 : _this_view.destroy();
    }
    toggleAnimation(shouldAnimate) {
        if (shouldAnimate) this.animationController.start();
        else this.animationController.stop();
    }
    constructor(uiGameManager, viewToPlaceAbove){
        this.uiGameManager = uiGameManager;
        const texture = UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.icon_beginner_hint);
        const height = this.uiGameManager.canvasController.itemSize * 0.6;
        const width = height * (texture.width / texture.height);
        const x = viewToPlaceAbove.x + viewToPlaceAbove.width / 2 - width / 2;
        this.initialY = viewToPlaceAbove.y - height * 1.2;
        this.view = new SpriteView(x, this.initialY, width, height, viewToPlaceAbove.parent, texture);
        this.view.zIndex = this.uiGameManager.mapController.mapView.layers.informationPopups;
        const maxAnimationDistance = this.view.height * 0.2;
        const animationSpeedMultiplier = 2;
        this.animationController = new UIGameVerticalMovementAnimation(this.view, maxAnimationDistance, animationSpeedMultiplier);
        this.animationController.start();
    }
}
